<template>
  <b-container class="bg-white">
    <b-row>
      <b-col cols="8" class="m-0 p-0" style="display: flex">
        <b-col class="infoCol align-items-center m-0 p-0">
          <div class="card-container">
            <div class="card card-logo">
              <div class="content">
                <img
                  :src="user.logotipo"
                  :alt="user.empresa"
                  style="max-height: 100%"
                />
              </div>
            </div>
          </div>
          <div class="info-plano-selecionado">
            <h4>{{ user.name }}</h4>
            <p>{{ user.cargo }}</p>
            <p>
              <font-awesome-icon :icon="['fas', 'envelope']" /> {{ user.email }}
            </p>
            <p><font-awesome-icon :icon="['fas', 'link']" /> {{ user.site }}</p>
            <p v-if="user.cartao">
              <font-awesome-icon
                :icon="['fas', 'address-card']"
                style="color: purple"
              />
              {{ user.cartao }}
            </p>
          </div>
          <div class="info-plano-selecionado">
            <p v-for="phone in user.telefones" :key="phone.id">
              <template v-if="phone.whatsapp == 0">
                <font-awesome-icon :icon="['fas', 'phone']" />
                ({{ phone.ddd }}) {{ phone.fone }}
              </template>
              <template v-else>
                <font-awesome-icon :icon="['fab', 'whatsapp']" />
                ({{ phone.ddd }}) {{ phone.fone }}
              </template>
            </p>
          </div>
        </b-col>
      </b-col>
      <b-col cols="4" class="m-0 p-0">
        <div class="card-container float-right">
          <div class="info-plano-selecionado text-right">
            <h4>{{ filtros.cidade.cidade }} - {{ filtros.cidade.uf }}</h4>
            <p v-if="textCredenciado">{{ textCredenciado }}</p>
            <p>Compulsório: {{ textCom }}</p>
            <p>Coparticipação: {{ textCop }}</p>
            <p>Acomodação: {{ textAcom }}</p>
            <p>Aceita MEI: {{ textMei }}</p>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="mt-2 p-0">
        <table
          id="table-group"
          class="border table-sm overflowing-right"
          style="font-size: 100px;"
        >
          <template v-for="(cenario, index) in cenarios">
            <thead :key="`linha-cabecalho-${index}`">
              <tr>
                <th class="eixo white"></th>
                <th
                  class="operadora white"
                  :colspan="parsePlanos(operadora.grupos).length"
                  v-for="(operadora, indexo) in cenario.operadoras"
                  :key="`logo-operadora-${index}-${operadora.id}-${indexo}`"
                >
                  <div
                    class="logo"
                    :style="
                      `border-color: ${
                        operadora.cor
                          ? '#' + operadora.cor.replace('#', '')
                          : 'grey'
                      };`
                    "
                  >
                    <img
                      :src="operadora.logotipoavo"
                      :alt="operadora.nome"
                      :title="operadora.nome"
                    />
                  </div>
                </th>
              </tr>
              <tr class="alternate">
                <th class="bordazIndex eixo">
                  <div
                    class="row text-left ml-2 no-gutters align-center justify-center"
                  >
                    <div class="text-no-wrap col">
                      <span class="grupo" :data-id="cenario.id">{{
                        cenario.nome
                      }}</span>
                      <br />
                      <small>{{ vidas(cenario) }} vidas</small>
                    </div>
                  </div>
                </th>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <th
                    class="text-center"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="
                      `coluna-operadora-${index}-${plano.id}-${indexo}-${indexp}`
                    "
                  >
                    <div class="plano-area">
                      <div
                        class="mb-n1"
                        style="font-size: 12px"
                        v-if="plano.admin_nome && plano.entidade_nome"
                      >
                        {{ plano.admin_nome ? plano.admin_nome : "" }} -
                        {{ plano.entidade_nome ? plano.entidade_nome : "" }}
                      </div>
                      <div class="mb-n1" style="font-size: 12px">
                        {{ plano.produto.nome }}
                      </div>
                      <div class="mw80">
                        <span
                          style="
                            font-size: 0.7rem !important;
                            font-weight: 600;
                            line-height: 1.75;
                            cursor: pointer;
                            opacity: 1;
                            filter: alpha(opacity=100);
                            transition: all 150ms linear;"
                        >
                          {{ plano.nome }} <br />
                        </span>
                        <template v-if="plano.alertas && plano.alertas.length > 0">
                          <b-icon icon="info-circle-fill" variant="warning"></b-icon>
                          <span style="font-size: 10px; font-weight: bold; text-transform: uppercase;">
                            {{ plano.alertas.join('') }}
                          </span>
                        </template>
                      </div>
                    </div>
                  </th>
                </template>
              </tr>
            </thead>
            <tbody :key="`linha-recomendar-${index}`" v-if="showRows('recomendar')">
              <transition name="fade">
                <tr>
                  <td class="bordazIndex">
                    Recomendar
                  </td>
                  <template v-for="operadora in cenario.operadoras">
                    <b-td
                      v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                      :key="`recomendar-${plano.id}-${indexp}`"
                      role="cell"
                      class="text-center"
                    >
                      <div
                        style="
                          max-width: 200px;
                          height: 100%;
                          font-size: 10px;
                          padding: 5px;
                          text-align: center;
                          background-color: transparent;
                          margin: 0 auto;
                        "
                        v-if="showRecomendar(cenario, plano)"
                        :id="`textarea-recomendar-${cenario.id}-${plano.id}`"
                      >
                        {{ plano.recomendar }}
                      </div>
                      <div v-else>-</div>
                    </b-td>
                  </template>
                </tr>
              </transition>
            </tbody>
            <tbody :key="`linha-atuacao-${index}`" v-if="showRows('atuacao')">
              <tr class="alternate">
                <td class="bordazIndex p-2">Atuação</td>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <b-td
                    class="text-center p-2"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="`atuacao-${index}-${indexo}-${plano.id}-${indexp}`"
                  >
                    <span>{{ plano.atuacao }}</span>
                  </b-td>
                </template>
              </tr>
            </tbody>
            <tbody :key="`linha-modalidade-${index}`" v-if="showRows('modalidade')">
              <tr class="bordazIndex">
                <td class="p-2">Modalidade</td>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <b-td
                    class="text-center p-2"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="`modalidade-${index}-${indexo}-${plano.id}-${indexp}`"
                  >
                    <span>{{ plano.modalidade }}</span>
                  </b-td>
                </template>
              </tr>
            </tbody>
            <tbody :key="`linha-acomodacao-${index}`" v-if="showRows('acomodacao')">
              <tr class="alternate">
                <td class="bordazIndex p-2">Acomodação</td>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <b-td
                    class="text-center p-2"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="`acomodacao-${index}-${indexo}-${plano.id}-${indexp}`"
                  >
                    <span>{{ plano.acomodacao }}</span>
                  </b-td>
                </template>
              </tr>
            </tbody>
            <tbody :key="`linha-coparticipacao-${index}`" v-if="showRows('coparticipacao')">
              <tr>
                <td class="bordazIndex p-2">Coparticipação</td>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <b-td
                    class="text-center p-2"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="
                      `coparticipacao-${index}-${indexo}-${plano.id}-${indexp}`
                    "
                  >
                    <span>
                      {{ plano.coparticipacao ? "Sim" : "Não" }}
                    </span>
                  </b-td>
                </template>
              </tr>
            </tbody>
            <tbody :key="`linha-reembolso-${index}`" v-if="showRows('reembolso')">
              <tr class="alternate">
                <td class="bordazIndex p-2">Reembolso</td>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <b-td
                    class="text-center p-2"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="`reembolso-${index}-${indexo}-${plano.id}-${indexp}`"
                  >
                    <span>
                      {{ plano.reembolso == '1' ? "Sim" : "Não" }}
                    </span>
                  </b-td>
                </template>
              </tr>
            </tbody>
            <tbody :key="`linha-taxas-${index}`" v-if="showRows('taxas-iof')">
              <tr>
                <td class="bordazIndex p-2">Taxas/IOF</td>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <b-td
                    class="text-center p-2"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="`iof-${index}-${indexo}-${plano.id}-${indexp}`"
                  >
                    <span v-if="!plano.taxas.descricao">
                      {{ plano.taxas.iof ? "Sim" : "Não" }}
                    </span>
                    <b-button
                      v-else
                      variant="link"
                      class="shadow-none"
                      v-b-popover.hover="plano.taxas.descricao"
                      title=""
                    >
                      <font-awesome-icon :icon="['fas', 'search-dollar']" />
                      {{ plano.taxas.iof ? "Sim" : "Não" }}
                    </b-button>
                  </b-td>
                </template>
              </tr>
            </tbody>
            <tbody :key="`linha-mei-${index}`" v-if="showRows('mei')">
              <tr>
                <td class="bordazIndex p-2">Aceita MEI</td>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <b-td
                    class="text-center p-2"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="`mei-${index}-${indexo}-${plano.id}-${indexp}`"
                  >
                    <span>
                      {{ plano.mei ? "Sim" : "Não" }}
                    </span>
                  </b-td>
                </template>
              </tr>
            </tbody>
            <!-- <tbody :key="`linha-informacao-${index}`">
              <tr class="alternate">
                <td class="white">Informações</td>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <b-td
                    class="white text-center"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="`informacoes-${index}-${indexo}-${plano.id}-${indexp}`"
                  >
                    <small class="pointer primary--text"
                      @click="maisInformacoes(cenario.id, operadora.id, plano)">
                      + informações
                    </small>
                  </b-td>
                </template>
              </tr>
            </tbody> -->
            <tbody :key="`linha-redes-${index}`" class="mw80 ma-4 pa-4" v-if="showRows('hospitais')">
              <tr class="alternate">
                <td class="bordazIndex px-0">
                  <div
                    class="row text-left ml-0 no-gutters align-center justify-center"
                  >
                    <div class="col">
                      <span
                        style="
                        color: #4d5656;
                        font-size: 0.8rem !important;
                      "
                      >
                        Hospitais
                      </span>
                    </div>
                  </div>
                </td>
                <template v-for="operadora in cenario.operadoras">
                  <td
                    class="text-center rede-sumario p-2"
                    v-for="plano in parsePlanos(operadora.grupos)"
                    :key="plano.id"
                  >
                    <small v-if="plano.filtros.tipo_plano != 'o'"
                      >{{
                        totalHospitais(plano, cenario.regioes)
                      }}
                      Hospitais</small
                    >
                    <small v-if="plano.filtros.tipo_plano != 'o'"
                      >{{ totalCentros(plano, cenario.regioes) }} Centros</small
                    >
                    <small v-if="plano.filtros.tipo_plano != 'o'"
                      >{{
                        totalLaboratorios(plano, cenario.regioes)
                      }}
                      Laboratórios</small
                    >
                    <small v-if="plano.filtros.tipo_plano == 'o'">-</small>
                  </td>
                </template>
              </tr>
            </tbody>
            <transition-group
              name="list"
              tag="tbody"
              :key="`linha-regioes-${index}`"
              class="mw80 ma-4 pa-4"
            >
              <template v-if="showHospitais">
                <template v-for="(regiao, rindex) in searchRedes(cenario.id)">
                  <tr
                    class="header"
                    :key="`tr-regioes-${index}-${regiao.id}-${rindex}`"
                  >
                    <td
                      class="px-0 border-bottom"
                      :colspan="colspanPlanos(cenario)"
                    >
                      <div class="ml-2 no-gutters">
                        <b :inner-html.prop="regiao.nome"></b>
                      </div>
                    </td>
                  </tr>
                  <template v-if="showRegiao(cenario, regiao)">
                    <template v-for="(cidade, cindex) in regiao.cidades">
                      <tr
                        class="header"
                        :key="
                          `tr-cidades-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}`
                        "
                      >
                        <td
                          class="px-0 border-bottom"
                          :colspan="colspanPlanos(cenario)"
                          :key="
                            `td-cidades-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}`
                          "
                        >
                          <div class="ml-2 no-gutters">
                            <span
                              class="fz-14"
                              :inner-html.prop="cidade.nome"
                            />
                          </div>
                        </td>
                      </tr>
                      <template v-if="showCidade(cenario, cidade)">
                        <template
                          v-for="(tipo, i) in Object.keys(cidade.credenciados)"
                        >
                          <tr
                            class="header"
                            :key="
                              `tr-credenciados-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${i}`
                            "
                          >
                            <th class="eixo" :colspan="colspanPlanos(cenario)">
                              <div
                                class="row text-left ml-4 no-gutters align-center justify-center"
                              >
                                {{ tipo }}
                              </div>
                            </th>
                          </tr>
                          <tr
                            :class="{ alternate: crindex % 2 == 0 }"
                            v-for="(credenciado, crindex) in cidade
                              .credenciados[tipo]"
                            :key="
                              `tr-credenciados-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${i}-${crindex}`
                            "
                          >
                            <td class="bordazIndex">
                              <div
                                class="row text-left ml-4 no-gutters align-center justify-center"
                                style="max-width: 90px;"
                                :inner-html.prop="
                                  credenciado.resumo
                                    ? credenciado.resumo
                                    : credenciado.nome
                                "
                              ></div>
                            </td>
                            <td
                              v-for="(plano, index) in cabCredPlanos(cenario)"
                              :key="
                                `tr-credenciados-${index}-${regiao.id}-${rindex}-${cidade.id}-${cindex}-${i}-${crindex}-${index}`
                              "
                              class="text-center rede-sumario p-2"
                            >
                              <span
                                :inner-html.prop="
                                  cobCredPlanos(plano, credenciado)
                                "
                              />
                              <span
                                :inner-html.prop="
                                  cobObsPlanos(plano, credenciado)
                                "
                              />
                            </td>
                          </tr>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </template>
            </transition-group>

            <tbody :key="`linha-obs-rede-${index}`" v-if="globalListaObsKeys.length > 0">
              <tr>
                <td class="bordazIndex p-2" :colspan="colspanPlanos(cenario)">
                  <div class="row">
                    <div class="col-3 col-sm-1 text-left pl-4">
                      Obs. Rede:
                    </div>
                    <div class="col-9 col-sm-10 text-left">
                      <ul :inner-html.prop="cobObsPlanosPrintAll()"  />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody :key="`linha-valores-${index}`" class="ma-4 pa-4" v-if="showRows('valores')">
              <tr class="header">
                <td class="px-0">
                  <div
                    class="row text-left ml-0 no-gutters align-center justify-center"
                  >
                    <div class="col">
                      <span
                        style="
                          color: #4d5656;
                          font-size: 0.8rem !important;
                        "
                      >
                        Valores
                      </span>
                    </div>
                  </div>
                </td>
                <template v-for="(operadora, indexo) in cenario.operadoras">
                  <b-td
                    class="text-center"
                    v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                    :key="
                      `valores-total-${index}-${indexo}-${plano.id}-${indexp}`
                    "
                  >
                    <transition name="fade">
                      <span
                        class="text-no-wrap"
                        style="width: 2%"
                        v-if="!showValores"
                      >
                        <span class="valor-sumario">
                          {{ calcularTotal(plano) | valor }}
                        </span>
                      </span>
                    </transition>
                  </b-td>
                </template>
              </tr>
              <template v-for="(faixa, indexf) in cenario.faixas">
                <transition name="fade" :key="faixa.slug" v-if="showFaixa(faixa)">
                  <tr
                    v-if="showValores"
                    :class="{ alternate: indexf % 2 == 0 }"
                  >
                    <td>
                      <div class="w-100">
                        <label for="faixa" class="m-0 w-50 text-center">
                          {{ faixa.label }}
                        </label>
                        <input
                          :id="`${cenario.id}-faixa-${faixa.slug}`"
                          type="number"
                          min="0"
                          max="99"
                          class="m-0 mr-2 w-30 inputVidas text-center"
                          :data-cenarioId="cenario.id"
                          :data-slug="faixa.slug"
                          v-model="faixa.value"
                          style="float: right;"
                          disabled
                        />
                      </div>
                    </td>
                    <template v-for="(operadora, indexo) in cenario.operadoras">
                      <b-td
                        class="text-center p-2"
                        v-for="(plano, indexp) in parsePlanos(operadora.grupos)"
                        :key="
                          `valores-${index}-${indexf}-${indexo}-${plano.id}-${indexp}`
                        "
                      >
                        <span>{{
                          faixaDeValor(faixa.slug, plano.calculo.faixas) | valor
                        }}</span>
                      </b-td>
                    </template>
                  </tr>
                </transition>
              </template>
            </tbody>
          </template>
          <ResumoGeralTituloPrint :cenarios="cenarios" v-if="showRows('resumo')"/>
          <ResumoGeralVidasPrint :cenarios="cenarios" v-if="showRows('resumo')"/>
          <ResumoGeralGrupoPrint :cenarios="cenarios" v-if="showRows('resumo')"/>
          <ResumoGeralTotalPrint :cenarios="cenarios" v-if="showRows('resumo')"/>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12 border mt-2 mb-5">
        <h4 class="text-danger">IMPORTANTE - LEIA COM ATENÇÃO</h4>
        <div class="card-aviso text-danger">
          <p class="fz-12">As informações referentes a Preços, Redes, Carências, Documentações, Reembolsos e Condições Contratuais são <b>determinadas pelas</b> operadoras, seguradoras, 
              administradoras ou outras entidades responsáveis e <b>deverão ser verificadas e conferidas junto</b> à respectiva <b>antes da CONTRATAÇÃO.</b></p>
          <p class="fz-12">Esta é uma <b>ferramenta de simulação</b> destinada a auxiliar no processo de pesquisa. Contudo, é importante destacar que <b>não nos responsabilizamos por possíveis 
          alterações que sejam feitas sem prévio aviso</b>. Para maiores informações e rede credenciada, consulte o site oficial da operadora. Quaisquer outras <b>dúvidas consulte o 
          corretor</b> que lhe enviou esta simulação.</p>
          <p class="fz-12"><b>Ressaltamos o nosso compromisso com a precisão das informações fornecidas</b>, no entanto, reservamo-nos o direito de corrigir eventuais erros identificados, esclarecendo 
          que tais correções <b>não estão vinculadas à efetivação do serviço</b>, que ocorrerá exclusivamente mediante a assinatura do contrato.</p>
          <p class="fz-12"><i>Aos valores apresentados não estão sendo somadas as taxas (exceto quando informado).</i></p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ResumoGeralTituloPrint from "../components/ResumoGeralTituloPrint.vue";
import ResumoGeralVidasPrint from "../components/ResumoGeralVidasPrint.vue";
import ResumoGeralGrupoPrint from "../components/ResumoGeralGrupoPrint.vue";
import ResumoGeralTotalPrint from "../components/ResumoGeralTotalPrint.vue";

export default {
  props: ["id"],
  components: {
    ResumoGeralTituloPrint,
    ResumoGeralVidasPrint,
    ResumoGeralGrupoPrint,
    ResumoGeralTotalPrint
  },
  data() {
    return {
      user: {
        name: '',
        login: '',
        logotipo: '',
        empresa: ''
      },
      cenarios: [],
      rows: [],
      filters: [],
      filtros: {
        cidade: ''
      },
      operadora: {
        nome: '',
        logotipoavo: '',
        logotipo: '',
        cidade: { id: '', cidade: '', uf: '' },
        tipo_plano: 's',
        coparticipacao: 2,
        compulsorio: 2,
        acomodacao: 2,
      },
      produto: {
        id: "",
        nome: "",
        cidade: "",
        carencias: "",
        docs: "",
        infos: "",
        reembolsos: ""
      },
      regioes: [],
      cidades: [],
      recomendar: [],
      showHospitais: false,
      showValores: false,
      globalListaObs: [],
      globalListaObsKeys: []
    };
  },
  methods: {
    ...mapActions("usuario", ["readSession"]),
    ...mapActions("carencia", ["buscaCarencia"]),
    parsePlanos(grupos) {
      return grupos.reduce(function(prev, curr) {
        return [...prev, ...curr.planos];
      }, []);
    },
    faixaDeValor(slug, faixas) {
      slug = slug == "59-99" ? "59-+" : slug;
      return faixas[slug] > 0 ? parseFloat(faixas[slug]) : "-";
    },
    calcular(a, b) {
      b = parseInt(b);
      return b != 0 ? (b *= parseFloat(a)).toFixed(2) : "-";
    },
    calcularTotal(plano) {
      return plano.filtros.regras_aceitacao && (plano.alertas && plano.alertas.length > 0)
        ? 0
        : plano.taxas.iof == true
        ? plano.calculo.total_iof
        : plano.calculo.total;
    },
    vidas(cenario) {
      return cenario.faixas
        .map(f => Number(f.value))
        .reduce((o, c) => parseInt(o) + parseInt(c));
    },
    totalHospitais(plano, regioes) {
      let total = 0;
      if(typeof regioes == 'object') {
        regioes.forEach(regiao => {
          regiao.cidades.forEach(cidade => {
            //console.log(cidade.credenciados["Hospitais"]);
            total += cidade.credenciados.hasOwnProperty("Hospitais")
              ? cidade.credenciados["Hospitais"].filter(
                  c =>
                    c.redes
                      .map(c => parseInt(c))
                      .indexOf(parseInt(plano.rede_id)) != -1
                ).length
              : 0;
          });
        });
      }
      return total;
    },
    totalCentros(plano, regioes) {
      let total = 0;
      if(typeof regioes == 'object') {
        regioes.forEach(regiao => {
          regiao.cidades.forEach(cidade => {
            total += cidade.credenciados.hasOwnProperty("Centros Médicos")
              ? cidade.credenciados["Centros Médicos"].filter(
                  c =>
                    c.redes
                      .map(c => parseInt(c))
                      .indexOf(parseInt(plano.rede_id)) != -1
                ).length
              : 0;
          });
        });
      }
      return total;
    },
    totalLaboratorios(plano, regioes) {
      let total = 0;
      if(typeof regioes == 'object') {
        regioes.forEach(regiao => {
          regiao.cidades.forEach(cidade => {
            total += cidade.credenciados.hasOwnProperty("Laboratórios")
              ? cidade.credenciados["Laboratórios"].filter(
                  c =>
                    c.redes
                      .map(c => parseInt(c))
                      .indexOf(parseInt(plano.rede_id)) != -1
                ).length
              : 0;
          });
        });
      }
      return total;
    },
    distinct(x, i, a) {
      return a.indexOf(x) === i;
    },
    cabCredPlanos(cenario) {
      //console.log("SimulacaoGrupo:cabCredPlanos");
      let planos = cenario.operadoras
        .reduce(function(prev, curr) {
          return [...prev, ...curr.grupos];
        }, [])
        .reduce(function(prev, curr) {
          return [...prev, ...curr.planos];
        }, []);

      let redes = cenario.redes.map(c => parseInt(c));
      return planos.filter(plano => {
        // Odonto não possui rede
        return plano.filtros.tipo_plano == "o"
          ? true
          : redes.indexOf(parseInt(plano.rede_id)) != -1;
      });
    },
    cobCredPlanos(plano, credenciado) {
      //ajustando para novo modelo de rede, deixar somente esta condição após setembro/2023
      if(typeof credenciado.cob == 'object') {
        return credenciado.redes
          .map(r => parseInt(r))
          .indexOf(parseInt(plano.rede_id)) != -1
          ? credenciado.cob[plano.rede_id]
              .split(",")
              .map(c => `<span>${c}</span>`)
              .join(",")
          : " - ";
      } else {
        return credenciado.redes
          .map(r => parseInt(r))
          .indexOf(parseInt(plano.rede_id)) != -1
          ? credenciado.cob
              .split(",")
              .map(c => `<span>${c}</span>`)
              .join(",")
          : " - ";
      }
    },
    cobObsPlanos(plano, credenciado) {
      if(!credenciado.hasOwnProperty('obs')) {
        return;
      }
      
      let id = 0;
      let key, obs;
      //ajustando para novo modelo de rede, deixar somente esta condição após setembro/2023
      if(typeof credenciado.obs == 'object') {
        if(typeof credenciado.obs[plano.rede_id] == 'undefined'){
          return '';
        }
        key = credenciado.obs[plano.rede_id].replace(/[^a-zA-Z0-9]/gi, '');
      } else {
        key = credenciado.obs.replace(/[^a-zA-Z0-9]/gi, '');
      }
      let index = this.globalListaObsKeys.indexOf(key);

      if(index == -1) {
        if(typeof credenciado.cob == 'object') {
          obs = credenciado.obs[plano.rede_id];
        } else {
          obs = credenciado.obs;
        }        
        obs = obs.replace(/(\<br \/\>|\<br\>)/gi, ', ');
        this.globalListaObs.push(obs);
        this.globalListaObsKeys.push(key)
        id = this.globalListaObs.length +1;
      } else {
        id = index+1;
      }
      return ` <span class="small">[${id}]</span>`
    },
    cobObsPlanosPrintAll() {
      let html = '';
      this.globalListaObsKeys.forEach((key, index) => {
        let c = index +1;
        html += `<li>[${c}]: ${this.globalListaObs[index]}</li>`
      })
      return html;
    },
    parsePlanos(grupos) {
      return grupos.reduce(function(prev, curr) {
        return [...prev, ...curr.planos];
      }, []);
    },
    parseRegioes(operadoras) {
      return operadoras.reduce(function(prev, curr) {
        return [...prev, ...curr.regioes];
      }, []);
    },
    mergeRegioes(operadoras) {
      let merged = {};
      operadoras.forEach(operadora => {
        _.merge(merged, operadora.regioes);
      });
      return merged;
    },
    colspanPlanos(cenario) {
      return (
        cenario.operadoras
          .reduce(function(prev, curr) {
            return [...prev, ...curr.grupos];
          }, [])
          .reduce(function(prev, curr) {
            return [...prev, ...curr.planos];
          }, []).length + 1
      );
    },
    showRecomendar(cenario, plano) {
      let show = false;
      if (this.recomendar.length > 0) {
        let c = this.recomendar.find(r => r.cenarioId == cenario.id);
        show = c ? c.planos.findIndex(r => r == plano.id) != -1 : false;

        if (cenario.id) {
          let vm = this;
          setTimeout(function() {
            const input = document.querySelector(
              `#textarea-recomendar-${cenario.id}-${plano.id}`
            );
            if (input) {
              const td = input.closest("td");
              const indexTd = vm.getTdIndex(td);
              const table = document.getElementById("table-group");
              const tds = table.querySelectorAll(`tr td:nth-child(${indexTd})`);
              if (show) {
                tds.forEach((td, index) => {
                  index % 2 == 1
                    ? td.classList.add("plano_selecionado")
                    : td.classList.add("plano_selecionado2");
                });
              } else {
                tds.forEach(td =>
                  td.classList.remove("plano_selecionado", "plano_selecionado2")
                );
              }
            }
          }, 800);
        }
      }
      return show;
    },
    getTdIndex(td) {
      let i = 1;
      while ((td = td.previousSibling) != null) i++;
      return i;
    },
    chunk(arr, size) {
      return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
        arr.slice(i * size, i * size + size)
      );
    },
    regiaoFields(planos) {
      let fields = [
        {
          key: "credenciado",
          stickyColumn: true,
          isRowHeader: true
        }
      ];
      for (let k in planos) {
        let plano = planos[k];
        fields.push(plano.nome + " " + plano.acomodacao);
      }
      return fields;
    },
    regiaoItems(planos) {
      let items = [];
      for (let k in planos) {
        let plano = planos[k];
        let atendimentos = Object.keys(plano.atendimentos);
        atendimentos.forEach(key => {
          let arr = {};
          let i = items.findIndex(a => a.credenciado === key);
          arr[plano.nome + " " + plano.acomodacao] = plano.atendimentos[key];
          if (i == -1) {
            items.push({ credenciado: key, ...arr });
          } else {
            items[i] = {
              ...items[i],
              ...arr
            };
          }
        });
      }
      return items;
    },
    showRegiao(cenario, regiao) {
      let show = false;
      if (this.regioes.length > 0) {
        let c = this.regioes.find(r => r.cenarioId == cenario.id);
        show = c ? c.regioes.findIndex(r => r == regiao.id) != -1 : false;
      }
      return show;
    },
    showCidade(cenario, cidade) {
      let show = false;
      if (this.cidades.length > 0) {
        let c = this.cidades.find(r => r.cenarioId == cenario.id);
        show = c ? c.cidades.findIndex(r => r == cidade.id) != -1 : false;
      }
      return show;
    },
    showRows(key) {
      let show = this.rows && this.rows.length > 0 ? this.rows.filter(t => t.key == key && t.show == 1).length > 0 : false
      return show;
    },
    showFaixa(faixa) {
      let show = true;
      let ops = [...this.filters]
      let filter = ops.filter(filter => filter.data.item == 'valores')
      let obj = filter.length > 0 ? filter.shift(1) : {}
      let state = obj.hasOwnProperty('state') ? obj.state.indeterminate || obj.state.checked : false;
      if (state) {
        show = obj.children.filter(c => {
          let slug = `${c.data.min.toString().padStart(2, "0")}-${c.data.max.toString().padStart(2, "0")}`;
          return slug == faixa.slug && (c.hasOwnProperty('state') ? c.state.indeterminate || c.state.checked : false)
        }).length > 0
      }
      return show;
    },
    searchRedes(cenarioId) {
      let self = this;
      let filterRedeChildren = this.children(this.filters, 'hospitais').find(c => c.data.id == cenarioId).children
      //console.log(filterRedeChildren)
      let cenario = this.cenarios.find(c => c.id == cenarioId)
      let regioes = JSON.parse(JSON.stringify(cenario.regioes));
      regioes = regioes.filter(regiao => {
        if (!self.checked(filterRedeChildren, regiao.nome)) return false
        let filterRegiaoChildren = self.children(filterRedeChildren, regiao.nome)
        regiao.cidades = regiao.cidades.filter(cidade => {
          if (!self.checked(filterRegiaoChildren, cidade.nome)) return false
          let filterCidadeChildren = self.children(filterRegiaoChildren, cidade.nome)
          let hospitais = []
          let laboratorios = []
          let centros = []
          if (cidade.credenciados.hasOwnProperty('Hospitais') && self.checked(filterCidadeChildren, 'Hospitais')) {
            let filterHospitalChildren = self.children(filterCidadeChildren, 'Hospitais')
            hospitais = cidade.credenciados['Hospitais'].filter(cred => {
              if (!self.checked(filterHospitalChildren, cred.id)) return false
              return true
            })
          }
          if (cidade.credenciados.hasOwnProperty('Laboratórios') && self.checked(filterCidadeChildren, 'Laboratórios')) {
            let filterLaboratorioChildren = self.children(filterCidadeChildren, 'Laboratórios')
            laboratorios = cidade.credenciados['Laboratórios'].filter(cred => {
              if (!self.checked(filterLaboratorioChildren, cred.id)) return false
              return true
            })
          }
          if (cidade.credenciados.hasOwnProperty('Centros Médicos') && self.checked(filterCidadeChildren, 'Centros Médicos')) {
            let filterCentroMedicoChildren = self.children(filterCidadeChildren, 'Centros Médicos')
            centros = cidade.credenciados['Centros Médicos'].filter(cred => {
              if (!self.checked(filterCentroMedicoChildren, cred.id)) return false
              return true
            })
          }
          cidade.credenciados['Hospitais'] = hospitais
          if (hospitais.length == 0) delete cidade.credenciados['Hospitais']
          cidade.credenciados['Laboratórios'] = laboratorios
          if (laboratorios.length == 0) delete cidade.credenciados['Laboratórios']
          cidade.credenciados['Centros Médicos'] = centros
          if (centros.length == 0) delete cidade.credenciados['Centros Médicos']
          if (Object.values(cidade.credenciados).flat().length > 0) {
            return true
          } else {
            return true;
          }
        });
        if (regiao.cidades.length > 0) {
          return true
        } else {
          return true
        }
      });
      return regioes
    },
    replaceSepecialChars(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    checked(filters, type) {
      let ops = [...filters]
      let filter = ops.filter(filter => filter.data.item == type)
      let obj = filter.length > 0 ? filter.shift(1) : {}
      return obj.hasOwnProperty('state') ? obj.state.indeterminate || obj.state.checked : false
    },
    children(filters, key) {
      let filter = filters.find(f => f.data.item == key)
      return filter ? filter.children : []
    },
  },
  computed: {
    ...mapGetters("usuario", ["getSession"]),
    ...mapGetters("carencia", {
      loadingCarencias: "getLoading"
    }),
    baseStyles() {
      return {
        "--minWidth": (this.total + 2) * 100 + "px",
        "--freezeWidth": this.$isMobile() ? "auto" : "155px",
        "--viewportSize": this.viewportSize + "px"
      };
    },
    textCredenciado() {
      return this.filtros.credenciado ? this.filtros.credenciado.nome : "";
    },
    textCop() {
      return this.filtros.coparticipacao > 1
        ? "indiferente"
        : this.filtros.coparticipacao == 1
        ? "sim"
        : "não";
    },
    textCom() {
      return this.filtros.compulsorio > 1
        ? "indiferente"
        : this.filtros.compulsorio == 1
        ? "sim"
        : "não";
    },
    textAcom() {
      return this.filtros.acomodacao > 1
        ? "indiferente"
        : this.filtros.acomodacao == 1
        ? "apartamento"
        : "enfermaria";
    },
    textMei() {
      return this.filtros.mei > 1
        ? "indiferente"
        : this.filtros.mei == 1
        ? "sim"
        : "não";
    },
    tipoPlano() {
      let tipo_plano = "";
      switch (this.operadora.tipo_plano) {
        case "o":
          tipo_plano = "Odonto";
          break;
        case "a":
          tipo_plano = "Adesão";
          break;
        case "s":
        default:
          tipo_plano = "Saúde";
          break;
      }
      return tipo_plano;
    },
    contratacao() {
      return this.operadora.contratacao.toUpperCase();
    }
  },
  async created() {
    await this.readSession({
      id: this.$route.query.hash
    });

    const session = this.getSession;
    this.cenarios = session.cenarios;
    this.user = session.user;
    this.filters = session.filters;
    this.rows = session.rows;
    const cenario = this.cenarios[0];
    const operadora = cenario.operadoras[0];

    this.filtros = operadora.filtros;
    this.regioes = JSON.parse(localStorage.getItem("toggleAllRegiao"));
    this.cidades = JSON.parse(localStorage.getItem("toggleAllCidade"));
    this.recomendar = JSON.parse(localStorage.getItem("toggleRecomendar")) || [];
    this.showHospitais = Boolean(
      parseInt(localStorage.getItem("showHospitais"))
    );
    this.showValores = Boolean(parseInt(localStorage.getItem("showValores")));

    setTimeout(() => {
      window.print();
    }, 3000);
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: rgb(255, 255, 255) !important;
}
span {
  color: #4d5656;
  font-size: 9pt;
}
small {
  font-size: 8pt;
}
table {
  thead tr:first-child th {
    position: unset;
  }
  thead tr:nth-child(2) th {
    position: unset;
  }
  th {
    font-size: 10px !important;
    padding: 5px !important;
  }
  td {
    font-size: 10px !important;
    padding: 5px !important;
  }
}

div.info-plano-selecionado {
  display: inline-block;
  vertical-align: top;

  padding: 5px 8px;
  & h4 {
    margin: 0;
  }
  & h6 {
    font-weight: normal;
    margin-top: 4px;
  }
  & p {
    font-size: 12px;
    margin: 5px 0px;
  }
}

.card-logo {
  padding: 12px;
  color: #757575;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12),
    0 3px 1px -2px rgba(0, 0, 0, 0.2);
  width: 150px;
  height: 112.5px;
  margin: 10px;
  margin-bottom: 10px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo img {
  width: 120px;
}
.infoCol {
  display: flex;
}
.impressao {
  h5 {
    border: 1px solid #ccc;
    padding: 5px;
  }
}
.carencias .card-body > div > div,
.docs .card-body > div > div,
.infos .card-body > div > div {
  padding: 5px;
}
.infos p {
  font-size: 12px;
}
/*
.redes, .reembolsos {
  overflow: hidden !important;
}
*/
@media only screen and (max-width: 700px) {
  div.logo-corretora {
    margin-left: 0 !important;
  }
  div.logo-corretora .card-logo,
  div.logo-operadora .card-logo {
    width: 125px;
  }
}
@media print {
  /* div.page .border {
    border: none;
  }
  h2,
  h3,
  h4 {
    page-break-before: always;
  }
  h5,
  h6 {
    page-break-after: avoid;
  }
  pre,
  blockquote {
    page-break-inside: avoid;
  } */
}

//Linha do Operado/Logo

.operadora > .logo {
  background-color: #fff;
  border-bottom: solid grey;
  height: 75px;
  padding: 0 10px 5px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
}
.operadora > .logo img {
  max-height: 100%;
  max-width: 120px;
}

//zebrada
table#table-group {
  width: 100%;
}
table#table-group > thead > tr > th,
table#table-group > tbody > tr > th,
table#table-group > tfoot > tr > th,
table#table-group > thead > tr > td,
table#table-group > tbody > tr > td,
table#table-group > tfoot > tr > td {
  background-color: #fff;
}

table#table-group tr.alternate th,
table#table-group tr.alternate td {
  background-color: #f2f2f2;
  -webkit-print-color-adjust: exact;
  border-top: none;
  border-bottom: none;
}
table#table-group thead tr:first-child th {
  position: relative;
  top: 0;
  z-index: 2;
}
.card-aviso p {
  color: #b92331;

  font-size: 12px;
  line-height: 1.4em;
}

//Alterações

.textChecked {
  display: none;
}
.custonCheck {
  display: flex;
  justify-content: center;
}

.testando {
  width: 230px !important;
}

//Table 2

.resumoGeral {
  float: left;
  font-size: 1.1rem;
  font-weight: 400;
  margin: 0;
}

.resumoGeralTH {
  width: 900px !important;
}

.resGeralAling {
  display: flex;
  justify-content: space-between;
}

.alinharValores {
  text-align: center;
  color: #4d5656;
}

.bordazIndex {
  border-right: 1px solid #dee2e6 !important;
}

.plano_selecionado {
  background-color: #f3dc83 !important;
}
.plano_selecionado2 {
  background-color: #f3dc8388 !important;
}

.custom-control {
  z-index: 0;
}

.no-border {
  border: none;
}

.textColor {
  color: #4d5656;
}
.rede-sumario small {
  clear: both;
  display: block;
}
</style>
